module.exports = __webpack_public_path__ + "static/img/icon-sort-4.857bfd1.png";